export const INVITE_TYPE_QUERY_PARAM = 'inviteType';
export const BRANDING_NAME_QUERY_PARAM = 'brandingName';
